module.exports = __webpack_public_path__ + "img/link.9daf83d.png";